import React, { useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import "../../Styles/faq.css";
import { faqApi } from "../../apis/faq/faqApi";

const Faq = () => {
  const [faq, setFaq] = useState([]);

  const fetchFaq = async () => {
    const response = await faqApi();
    const faqData = response.data.data;
    setFaq(faqData);
  };

  useEffect(() => {
    fetchFaq();
  }, []);

  return (
    <>
      <div className="container faq-container pb-5">
        <h3>Frequently Asked Questions</h3>

        <Accordion defaultActiveKey="0">
          {faq.map((data, index) => (
            <Accordion.Item eventKey={index.toString()} key={data.id}>
              <Accordion.Header>{data.question}</Accordion.Header>
              <Accordion.Body>
                {" "}
                <div
                  dangerouslySetInnerHTML={{ __html: data.answer }}
                ></div>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </>
  );
};

export default Faq;
